/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RemoveOAuthServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RemoveOAuthServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RemoveOAuthServerSecurity = {
  option1?: RemoveOAuthServerSecurityOption1 | undefined;
  option2?: RemoveOAuthServerSecurityOption2 | undefined;
};

export type RemoveOAuthServerRequest = {
  /**
   * The slug of the toolset
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type RemoveOAuthServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RemoveOAuthServerSecurityOption1$outboundSchema: z.ZodMiniType<
  RemoveOAuthServerSecurityOption1$Outbound,
  RemoveOAuthServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function removeOAuthServerSecurityOption1ToJSON(
  removeOAuthServerSecurityOption1: RemoveOAuthServerSecurityOption1,
): string {
  return JSON.stringify(
    RemoveOAuthServerSecurityOption1$outboundSchema.parse(
      removeOAuthServerSecurityOption1,
    ),
  );
}

/** @internal */
export type RemoveOAuthServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RemoveOAuthServerSecurityOption2$outboundSchema: z.ZodMiniType<
  RemoveOAuthServerSecurityOption2$Outbound,
  RemoveOAuthServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function removeOAuthServerSecurityOption2ToJSON(
  removeOAuthServerSecurityOption2: RemoveOAuthServerSecurityOption2,
): string {
  return JSON.stringify(
    RemoveOAuthServerSecurityOption2$outboundSchema.parse(
      removeOAuthServerSecurityOption2,
    ),
  );
}

/** @internal */
export type RemoveOAuthServerSecurity$Outbound = {
  Option1?: RemoveOAuthServerSecurityOption1$Outbound | undefined;
  Option2?: RemoveOAuthServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RemoveOAuthServerSecurity$outboundSchema: z.ZodMiniType<
  RemoveOAuthServerSecurity$Outbound,
  RemoveOAuthServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RemoveOAuthServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RemoveOAuthServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function removeOAuthServerSecurityToJSON(
  removeOAuthServerSecurity: RemoveOAuthServerSecurity,
): string {
  return JSON.stringify(
    RemoveOAuthServerSecurity$outboundSchema.parse(removeOAuthServerSecurity),
  );
}

/** @internal */
export type RemoveOAuthServerRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const RemoveOAuthServerRequest$outboundSchema: z.ZodMiniType<
  RemoveOAuthServerRequest$Outbound,
  RemoveOAuthServerRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function removeOAuthServerRequestToJSON(
  removeOAuthServerRequest: RemoveOAuthServerRequest,
): string {
  return JSON.stringify(
    RemoveOAuthServerRequest$outboundSchema.parse(removeOAuthServerRequest),
  );
}
